import React, { useState, useEffect, useRef } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/^http:\/\//i, 'https://');
const WS_URL = BACKEND_URL.replace(/^https/i, 'wss') + '/ws';

const LiveOddsIndicator = ({ sport = 'soccer' }) => {
  const [connected, setConnected] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [events, setEvents] = useState([]);
  const wsRef = useRef(null);
  const reconnectRef = useRef(null);

  useEffect(() => {
    const connect = () => {
      try {
        const ws = new WebSocket(`${WS_URL}/odds`);
        wsRef.current = ws;

        ws.onopen = () => {
          setConnected(true);
          ws.send(JSON.stringify({ league: sport === 'all' ? 'all' : sport }));
        };

        ws.onmessage = (e) => {
          try {
            const data = JSON.parse(e.data);
            if (data.type === 'odds_update') {
              setEvents(data.events || []);
              setLastUpdate(new Date().toLocaleTimeString());
            }
          } catch {}
        };

        ws.onclose = () => {
          setConnected(false);
          reconnectRef.current = setTimeout(connect, 5000);
        };

        ws.onerror = () => {
          setConnected(false);
        };
      } catch {
        setConnected(false);
        reconnectRef.current = setTimeout(connect, 5000);
      }
    };

    connect();

    return () => {
      if (wsRef.current) wsRef.current.close();
      if (reconnectRef.current) clearTimeout(reconnectRef.current);
    };
  }, [sport]);

  return (
    <div data-testid="live-odds-indicator" className="flex items-center gap-2 text-xs">
      {connected ? (
        <>
          <Wifi className="w-3.5 h-3.5 text-green-400" />
          <span className="text-green-400">Live WS</span>
          {lastUpdate && <span className="text-gray-500">{lastUpdate}</span>}
          {events.length > 0 && <span className="text-gray-400">{events.length} Events</span>}
        </>
      ) : (
        <>
          <WifiOff className="w-3.5 h-3.5 text-gray-500" />
          <span className="text-gray-500">Verbindung...</span>
        </>
      )}
    </div>
  );
};

export default LiveOddsIndicator;
